/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemSettingControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getSchedulingSettings(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/system-settings/scheduling',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateSchedulingSettings(
        requestBody: Record<string, any>,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/system-settings/scheduling',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getPlanningHorizonSettings(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/system-settings/planning-horizon',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updatePlanningHorizonSettings(
        requestBody: Record<string, any>,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/system-settings/planning-horizon',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns number OK
     * @throws ApiError
     */
    public static getMaxProductionLeadTimeDefault(): CancelablePromise<Record<string, number>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/system-settings/max-production-lead-time',
        });
    }
    /**
     * @param requestBody
     * @returns number OK
     * @throws ApiError
     */
    public static updateMaxProductionLeadTimeDefault(
        requestBody: Record<string, any>,
    ): CancelablePromise<Record<string, number>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/system-settings/max-production-lead-time',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getGeneralSettings(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/system-settings/general',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateGeneralSettings(
        requestBody: Record<string, any>,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/system-settings/general',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getDeliveryTimes(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/system-settings/delivery-times',
        });
    }
    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static updateDeliveryTimes(
        requestBody: Record<string, any>,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/system-settings/delivery-times',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
